/**
 * `/studio/money` — the run, the ledger, the failures and the Wise queue.
 *
 * `?period=` is the topbar's seg. The money page for a past month is a real address,
 * which is why the period is in the URL rather than in the component — and why it is
 * `routeSearch`: a month that is not a month is this month, not an error boundary
 * over the one screen the studio watches on the 1st.
 */

import { createFileRoute } from '@tanstack/react-router'

import { MoneyPage, MoneySearchSchema } from '../../pages/studio/money/MoneyPage.js'
import { routeSearch } from '../../search/useSearchState.js'

export const Route = createFileRoute('/studio/money')({
  validateSearch: routeSearch(MoneySearchSchema),
  component: MoneyPage,
})
